var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItalic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6855 3.41626H14.1667C14.581 3.41626 14.9167 3.75205 14.9167 4.16626C14.9167 4.58047 14.581 4.91626 14.1667 4.91626H12.2325L9.32764 15.0833H10.8333C11.2475 15.0833 11.5833 15.419 11.5833 15.8333C11.5833 16.2475 11.2475 16.5833 10.8333 16.5833H5.83325C5.41904 16.5833 5.08325 16.2475 5.08325 15.8333C5.08325 15.419 5.41904 15.0833 5.83325 15.0833H7.76761L10.6725 4.91626H9.16675C8.75253 4.91626 8.41675 4.58047 8.41675 4.16626C8.41675 3.75205 8.75253 3.41626 9.16675 3.41626H11.6473C11.66 3.41594 11.6727 3.41593 11.6855 3.41626Z",
    fill: "#2B2B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalic);
export default __webpack_public_path__ + "static/media/italic.81c42315ee0f2090693e5630deff2cb7.svg";
export { ForwardRef as ReactComponent };